import { render } from "./UtmEditor.vue?vue&type=template&id=204949cc&scoped=true"
import script from "./UtmEditor.vue?vue&type=script&lang=js"
export * from "./UtmEditor.vue?vue&type=script&lang=js"

import "./UtmEditor.vue?vue&type=style&index=0&id=204949cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204949cc"]])

export default __exports__